// Detect prefers-reduced-motion globally for use throughout the application
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
window.prefersReducedMotion = prefersReducedMotion;

//Nav on scroll and update logo color
document.addEventListener("DOMContentLoaded", () => {
	const header = document.getElementById('masthead');
	const navUtility = document.querySelector('#masthead .navigation-utility');

	const siteBranding = header.querySelector('.site-branding');
	const logoLink = document.querySelector('.custom-logo-link');
	const logoImg = logoLink.querySelector('img');

	const defaultLogo = siteBranding.dataset.logoUrl;
	const whiteLogo = siteBranding.dataset.whiteLogoUrl;
	const hasWhiteLogo = whiteLogo && whiteLogo!== "";

	function updateLogo() {

		if (!hasWhiteLogo) {
			logoImg.src = defaultLogo;
			return;
		}

		if (header.classList.contains('scrolled')) {
			logoImg.src = defaultLogo;
			return;
		}

		if (header.classList.contains('white-text')) {
			logoImg.src = whiteLogo;
		} else {
			logoImg.src = defaultLogo;
		}
	}

	function onScroll() {
		if (window.scrollY > 100) {
			header.classList.add('scrolled');
			header.setAttribute('style', 'position: fixed !important');
			navUtility.setAttribute('style', 'display: none !important');
		} else {
			header.classList.remove('scrolled');
			header.removeAttribute('style');
			navUtility.removeAttribute('style');
		}

		updateLogo();
	}

	updateLogo();
	window.addEventListener('scroll', onScroll);

	const observer = new MutationObserver(updateLogo);
	observer.observe(header, { attributes: true, attributeFilter: ['class'] });
});

// Mega sub menu mobile
document.addEventListener("DOMContentLoaded", () => {
	function handleMegaMenu() {
		if (window.innerWidth < 1120) {

			const megaMenu = document.getElementById('mega-menu-menu-1');
			const siteBranding = document.querySelector('.site-branding');

			if (megaMenu && !megaMenu.querySelector(".submenu-header")) {
				const megaMenuHeaderContainer = document.createElement("div");
				const siteBrandingCopy = siteBranding.cloneNode(true);

				const logoLinkCopy = siteBrandingCopy.querySelector('.custom-logo-link');
				if (logoLinkCopy) {
					const logoImgCopy = logoLinkCopy.querySelector('img');
					const defaultLogo = siteBrandingCopy.dataset.logoUrl;

					if (logoImgCopy && defaultLogo) {
						logoImgCopy.src = defaultLogo;
					}
				}

				megaMenuHeaderContainer.classList.add("submenu-header");
				megaMenu.prepend(megaMenuHeaderContainer);
				megaMenuHeaderContainer.appendChild(siteBrandingCopy);
			}

			document.querySelectorAll(".mega-menu-item-has-children:not(.mega-not-submenu)").forEach(item => {
				const menuLink = item.querySelector(".mega-menu-link");
				const subMenu = item.querySelector(".mega-sub-menu");

				if (menuLink && subMenu && !subMenu.querySelector(".submenu-header") && !subMenu.querySelector(".submenu-title") ) {

					const headerContainer = document.createElement("div");
					const titleContainer = document.createElement("div");
					headerContainer.classList.add("submenu-header");
					titleContainer.classList.add("submenu-title");

					const title = document.createElement("h2");
					title.textContent = menuLink.textContent.trim();

					const backButton = document.createElement("button");
					backButton.classList.add("back-button");
					backButton.innerHTML = `
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="16" cy="16" r="15.5" transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 32 32)" fill="#21201E" stroke="white"/>
				<path d="M17 20L13 16L17 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
          `;

					headerContainer.appendChild(backButton);
					titleContainer.appendChild(title);

					subMenu.prepend(titleContainer);
					subMenu.prepend(headerContainer);

					backButton.addEventListener("click", () => {
						item.classList.remove("mega-toggle-on");
					});
				}
			});
		} else {
			document.querySelectorAll(".submenu-header").forEach(header => header.remove());
			document.querySelectorAll(".submenu-title").forEach(title => title.remove());
		}
	}

	handleMegaMenu();
	window.addEventListener("resize", handleMegaMenu);
});

//mega-toggle-animated
document.addEventListener("DOMContentLoaded", () => {
	const toggleMenu = document.querySelector('.mega-toggle-animated ');

	toggleMenu.addEventListener("click", () => {
		const subMenuOpen = document.querySelector('.mega-menu-item-has-children.mega-toggle-on');
		if (subMenuOpen) {
			subMenuOpen.classList.remove('mega-toggle-on');
		}
	})
});

// Mega menu arrows accessibility
document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll('.mega-menu-item').forEach(item => {
		item.addEventListener('keydown', (e) => {
			if (e.key === 'ArrowDown') {
				const submenu = item.querySelector('.mega-sub-menu');
				if (submenu) {
					item.classList.add('mega-toggle-on');
					const firstLink = submenu.querySelector('a');
					if (firstLink) {
						firstLink.focus();
						e.preventDefault();
					}
				}
			}
		});
	});
});

// Mega submenu grid last row styles
document.querySelectorAll('.two-cols, .three-cols').forEach(grid => {

	const megaMenu = grid.querySelector('.mega-sub-menu');
	if (!megaMenu) return;

	const columns = grid.classList.contains('three-cols') ? 3 : 2;

	const items = [...megaMenu.children].filter(item =>
		!item.classList.contains('widget_custom_html')
	);

	items.forEach(item => item.classList.remove('last-row'));

	const total = items.length;

	const totalRows = Math.ceil(total / columns);

	if (totalRows <= 2) return;

	const startIndex = columns * 2; // saltear primeras 2 filas

	const lastRowItems = items.slice(startIndex);

	lastRowItems.forEach(item => {
		item.classList.add('last-row');
	});
});

// Move focus on submenu open
document.addEventListener('DOMContentLoaded', () => {
	let openedWithKeyboard = false;

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			openedWithKeyboard = true;
		}
	});
	document.addEventListener('mousedown', () => {
		openedWithKeyboard = false;
	});

	const items = document.querySelectorAll('.main-navigation .max-mega-menu > li.mega-menu-item');

	items.forEach(item => {
		const submenu = item.querySelector('.mega-sub-menu');
		if (!submenu) return;

		const parentLink = item.querySelector(':scope > a');

		const observer = new MutationObserver(() => {
			if (item.classList.contains('mega-toggle-on') && openedWithKeyboard) {

				const firstLink = submenu.querySelector('a');
				if (firstLink) {

					setTimeout(() => firstLink.focus(), 20);

					function onKeyDown(e) {
						if (e.shiftKey && e.key === 'Tab') {
							e.preventDefault();

							item.classList.remove('mega-toggle-on');
							parentLink.focus();

							firstLink.removeEventListener('keydown', onKeyDown);
						}
					}

					firstLink.addEventListener('keydown', onKeyDown);
				}
			}
		});

		observer.observe(item, { attributes: true, attributeFilter: ['class'] });
	});
});

// Announcement local storage
document.addEventListener("DOMContentLoaded", () => {
	const bar = document.getElementById("announcement-bar");
	const closeBtn = bar?.querySelector("button");

	if (!bar || !closeBtn) return;

	const STORAGE_KEY = "announcement_closed_at";
	const DAYS_TO_HIDE = 7;

	const lastClose = localStorage.getItem(STORAGE_KEY);
	let shouldShow = true;

	if (lastClose) {
		const closedAt = new Date(parseInt(lastClose, 10));
		const now = new Date();
		const diffDays = (now - closedAt) / (1000 * 60 * 60 * 24);

		if (diffDays < DAYS_TO_HIDE) {
			shouldShow = false;
		}
	}

	// The header is absolutely positioned, so the space the bar occupies has to
	// be reserved on the body. Its height is not fixed: the banner text wraps to
	// more lines as the viewport narrows, and at 400% zoom / 320px reflow it is
	// several times its desktop height. Measuring once on load leaves the reserved
	// space short after any reflow, dropping the nav row and the hero headline
	// behind the banner — so re-measure whenever the bar's box changes.
	function reserveBarSpace() {
		const height = bar.offsetHeight;

		// `.scrolled` hides the bar while the sticky header is up. Keep the last
		// reserved height so the page does not jump as the header swaps in.
		if (height > 0) {
			document.body.style.marginTop = `${height}px`;
		}
	}

	if (shouldShow) {
		bar.classList.remove("hidden");
		requestAnimationFrame(reserveBarSpace);

		if (typeof ResizeObserver !== "undefined") {
			new ResizeObserver(reserveBarSpace).observe(bar);
		} else {
			window.addEventListener("resize", reserveBarSpace);
		}
	}

	closeBtn.addEventListener("click", function () {
		localStorage.setItem(STORAGE_KEY, Date.now().toString());

		bar.remove();
		document.body.style.marginTop = "";
	});
});